<template>
  <section class="content-block">
    <transition name="fade">
      <div
        v-if="this.$store.state.isLoading"
        class="darken-bg is-flex"
      >
        <div class="block loading-block is-fixed is-center">
          <div class="control is-large is-loading" />
          <p class="connection-note">
            {{ $t("general.label.sendingData") }}
          </p>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'Start',
  data () {
    return {
        showContent_Input: false,
        showContent_Pricing: false
    }
  },
  mounted () {
  },
  methods: {
      closeModal () {
        this.showContent_Input = false
        this.showContent_Pricing = false
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.darken-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(60, 60, 60, 0.75);
    z-index: 100;

    .block {
        width: 90%;
        max-width: 500px;
        position: absolute;
        top: calc(50% - 100px);
        left: 0;
        right: 0;
        display: block;
        box-shadow: none;
        border: none;

        &.is-center {
            text-align: center;
        }

        .control {
            display: inline-block;
            width: 1.5rem;
            height: 1.5rem;
            margin-bottom: -0.5rem;
        }

        p {
            font-size: 1rem;
            color: #ffffff;
        }
    }

    .loading-block .button.is-loading::after, .loading-block .select.is-loading::after, .loading-block .control.is-loading::after, .loading-block .loader {
        border: 2px solid #ffffff;
        border-right-color: transparent;
        border-top-color: transparent;
    }
}

@media all and (min-width: 680px) and (max-width: 800px){ 
}

@media (max-width: 680px){ 

}
</style>
